// @ts-check

import React, { useEffect, useState } from "react";
import {
  DownOutlined,
  RightOutlined,
} from "@ant-design/icons";
import {
  Alert,
} from "antd";

import { styles } from "@evolved/constants";
import { RowInfo } from "./row-info";

/**
 * @param {Object} props 
 * @param {import("./domain").ReducedRow[]} props.reducedRows
 * @param {((info: import("./domain").ImportRowInfo) => boolean)} [props.filter]
 */
export const RowInfos = (props) => {
  const [show, setShow] = useState(10);

  useEffect(() => {
    setShow(10);
  }, [props.reducedRows]);
  const [isOpen, setIsOpen] = useState(false);

  const filtered = props.reducedRows.filter((row) => {
    return !props.filter || row.info.filter(props.filter).length;
  });

  if (!filtered.length) {
    return null;
  }

  return (
    <>
      <div className="mb-2" onClick={() => setIsOpen(!isOpen)}>
        <Alert
          onClick={() => setIsOpen(!isOpen)}
          message={
            <div className="font-bold flex cursor-pointer" onClick={() => setIsOpen(!isOpen)}>
              <div className="mr-4">
                {isOpen ? <DownOutlined /> : <RightOutlined />}
              </div>
              <div>{filtered.length} rows with potential issues</div>
            </div>
          }
          type="warning"
        />
      </div>
      {isOpen ? (
        <div className="overflow-y-scroll max-h-[500px] space-y-1">
          {filtered.slice(0, show).map((row, index) => {
            return (
              <RowInfo
                key={index}
                {...{
                  info: row.info,
                  index,
                }}
              />
            )
          })}
          {show < filtered.length ? (
            <div className="font-bold text-center" style={styles.CLICKABLE_STYLE} onClick={() => setShow(show + 10)}>Show More</div>
          ) : null}
        </div>
      ) : null}
    </>
  )
};
